import { render, staticRenderFns } from "./OModal.vue?vue&type=template&id=1c0d914d&"
import script from "./OModal.vue?vue&type=script&lang=js&"
export * from "./OModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports